/* ════════════════════════════════════════════════════════════
   PRODUCT PAGE JS — Shopify 2.0 / Thème Tinker (Horizon)
   Modules :
   1. Galerie (thumbnails)
   2. Sélecteur quantité (+/−)
   3. Remises par quantité (nudge dynamique)
   4. Sticky ATC bar (IntersectionObserver)
   5. Formulaire ATC (fetch API)
   6. Copie du lien (share)
   ════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── Sélecteurs utilitaires ─────────────────────────────── */
  const $  = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));

  /* ════════════════════════════════════════════════════════════
     1. GALERIE — Changement d'image via thumbnails
     ════════════════════════════════════════════════════════════ */
  function initGallery(sid) {
    const section   = $(`#MainProduct-${sid}`);
    if (!section) return;

    const mainImg   = $(`#ProductMedia-${sid} .product__media-img`, section);
    const mainWrap  = $(`#ProductMedia-${sid} .product__media-wrapper`, section);
    const thumbs    = $$('.product__thumb', section);

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.dataset.mediaSrc;
        if (!newSrc || !mainImg) return;

        /* Transition fluide */
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(.98)';

        setTimeout(() => {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 150);

        /* MAJ des états actifs */
        thumbs.forEach(t => {
          t.classList.remove('product__thumb--active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('product__thumb--active');
        thumb.setAttribute('aria-current', 'true');
      });
    });

    /* Transition image CSS */
    if (mainImg) {
      mainImg.style.transition = 'opacity .15s ease, transform .15s ease';
    }
  }

  /* ════════════════════════════════════════════════════════════
     2. SÉLECTEUR QUANTITÉ (+/−)
     ════════════════════════════════════════════════════════════ */
  function initQuantitySelector(sid) {
    const section = $(`#MainProduct-${sid}`);
    if (!section) return;

    const qtyInput = $(`#Qty-${sid}`, section);
    if (!qtyInput) return;

    /* Synchronise le champ caché dans le form */
    function syncHidden(val) {
      const hidden = $('[data-qty-sync]', section);
      if (hidden) hidden.value = val;
    }


    $$('[data-action]', $(`#ProductQty-${sid}`, section)).forEach(btn => {
      btn.addEventListener('click', () => {
        const action = btn.dataset.action;
        const current = parseInt(qtyInput.value, 10) || 1;
        const min = parseInt(qtyInput.min, 10) || 1;
        const max = parseInt(qtyInput.max, 10) || 9999;

        const next = action === 'plus'
          ? Math.min(current + 1, max)
          : Math.max(current - 1, min);

        qtyInput.value = next;
        syncHidden(next);

        /* Déclenche l'update des remises */
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    qtyInput.addEventListener('change', () => {
      syncHidden(qtyInput.value);
    });
  }

  /* ════════════════════════════════════════════════════════════
     3. REMISES PAR QUANTITÉ — Ligne active + nudge message
     ════════════════════════════════════════════════════════════ */
  function initQuantityDiscount(sid) {
    const section    = $(`#MainProduct-${sid}`);
    const qtyInput   = $(`#Qty-${sid}`, section);
    const nudgeEl    = $(`#QtyNudge-${sid}`, section);
    const tableEl    = $(`#QtyDiscount-${sid}`, section);
    if (!qtyInput || !tableEl) return;

    /* Parse les paliers depuis le DOM */
    const tiers = $$('.qty-tier', tableEl).map(row => ({
      qty:      parseInt(row.dataset.qty, 10),
      pct:      parseInt(row.dataset.pct, 10),
      element:  row,
    })).sort((a, b) => a.qty - b.qty);

    function updateDiscount(currentQty) {
      if (!tiers.length) return;

      /* Déterminer le palier actif */
      let active = tiers[0];
      tiers.forEach(t => {
        if (currentQty >= t.qty) active = t;
      });

      /* Prochain palier */
      const activeIdx = tiers.indexOf(active);
      const next = tiers[activeIdx + 1] || null;

      /* MAJ visuels */
      tiers.forEach(t => t.element.classList.remove('qty-tier--active'));
      active.element.classList.add('qty-tier--active');

      /* Message nudge */
      if (nudgeEl) {
        if (next) {
          const diff = next.qty - currentQty;
          nudgeEl.innerHTML =
            `💡 Ajoutez encore <strong>${diff} article${diff > 1 ? 's' : ''}</strong>` +
            ` pour bénéficier de <strong>-${next.pct}%</strong> par unité !`;
        } else if (active.pct > 0) {
          nudgeEl.innerHTML =
            `🏆 Bravo ! Vous bénéficiez de la <strong>meilleure remise : -${active.pct}%</strong> !`;
        } else {
          nudgeEl.innerHTML = '';
        }
      }
    }

    /* Écoute les changements de quantité */
    qtyInput.addEventListener('change', e => {
      updateDiscount(parseInt(e.target.value, 10) || 1);
    });

    /* Initialisation */
    updateDiscount(parseInt(qtyInput.value, 10) || 1);
  }

  /* ════════════════════════════════════════════════════════════
     4. STICKY ATC BAR — IntersectionObserver
     ════════════════════════════════════════════════════════════ */
  function initStickyATC(sid) {
    const stickyBar  = $(`#StickyATC-${sid}`);
    const buyBlock   = $(`#ProductBuy-${sid}`);
    if (!stickyBar || !buyBlock) return;

    const stickyBtn  = $(`#StickyATCBtn-${sid}`);
    const formId     = stickyBtn?.dataset.form;
    const mainForm   = formId ? $(`#${formId}`) : null;

    /* Observer : affiche la barre quand les boutons sortent du viewport */
    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.setAttribute('aria-hidden', String(!visible));
      },
      {
        threshold:  0,
        rootMargin: `-${parseInt(getComputedStyle(document.documentElement)
                      .getPropertyValue('--pp-header-h') || '72', 10)}px 0px 0px 0px`,
      }
    );

    observer.observe(buyBlock);

    /* Clic sticky → soumet le form principal */
    stickyBtn?.addEventListener('click', () => {
      if (!mainForm) return;

      /* Synchronise quantité */
      const qtyInput = $(`#Qty-${sid}`);
      const hiddenQty = mainForm.querySelector('[data-qty-sync]');
      if (qtyInput && hiddenQty) hiddenQty.value = qtyInput.value;

      /* Soumet */
      mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* ════════════════════════════════════════════════════════════
     5. FORMULAIRE ATC — Fetch API avec état de chargement
     ════════════════════════════════════════════════════════════ */
  function initAddToCart(sid) {
    const section = $(`#MainProduct-${sid}`);
    const form    = $(`#ProductForm-${sid}`, section);
    const atchBtn = $(`#AddToCart-${sid}`, section);
    if (!form || !atchBtn) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      /* Synchronise quantité */
      const qtyInput  = $(`#Qty-${sid}`, section);
      const hiddenQty = form.querySelector('[data-qty-sync]');
      if (qtyInput && hiddenQty) hiddenQty.value = qtyInput.value;

      /* État chargement */
      atchBtn.classList.add('btn--loading');
      atchBtn.setAttribute('aria-busy', 'true');
      atchBtn.disabled = true;

      try {
        const fd = new FormData(form);
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method:  'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body:    fd,
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || 'Erreur lors de l\'ajout au panier.');
        }

        /* Succès */
        atchBtn.classList.remove('btn--loading');
        atchBtn.setAttribute('aria-busy', 'false');

        const origHTML = atchBtn.innerHTML;
        atchBtn.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
          '<span class="btn__label">Ajouté au panier !</span>';
        atchBtn.disabled = false;

        /* Dispatch événement pour le cart drawer Tinker/Horizon */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open',    { bubbles: true }));

        setTimeout(() => {
          atchBtn.innerHTML = origHTML;
        }, 2500);

      } catch (err) {
        console.error('[ProductPage ATC]', err);
        atchBtn.classList.remove('btn--loading');
        atchBtn.setAttribute('aria-busy', 'false');
        atchBtn.disabled = false;

        /* Feedback d'erreur visuel */
        const origHTML = atchBtn.innerHTML;
        atchBtn.innerHTML = '<span class="btn__label">⚠️ ' + (err.message || 'Erreur') + '</span>';
        atchBtn.style.background = 'var(--pp-warning)';
        setTimeout(() => {
          atchBtn.innerHTML = origHTML;
          atchBtn.style.background = '';
        }, 3000);
      }
    });
  }

  /* ════════════════════════════════════════════════════════════
     6. COPIE DU LIEN (Share)
     ════════════════════════════════════════════════════════════ */
  function initShareCopy(sid) {
    const section = $(`#MainProduct-${sid}`);

    $$('[data-copy-url]', section).forEach(btn => {
      btn.addEventListener('click', async () => {
        const url = btn.dataset.copyUrl;
        if (!url) return;

        try {
          await navigator.clipboard.writeText(url);
          const orig = btn.innerHTML;
          btn.innerHTML =
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
          btn.setAttribute('aria-label', 'Lien copié !');
          btn.title = 'Lien copié !';

          setTimeout(() => {
            btn.innerHTML = orig;
            btn.setAttribute('aria-label', 'Copier le lien');
            btn.title = '';
          }, 2200);
        } catch {
          /* Fallback pour navigateurs non compatibles */
          const ta = Object.assign(document.createElement('textarea'), {
            value: url,
            style: 'position:absolute;opacity:0',
          });
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
      });
    });
  }

  /* ════════════════════════════════════════════════════════════
     INIT — Détecte toutes les sections produit
     ════════════════════════════════════════════════════════════ */
  function init() {

    $$('[data-section-type="product"]').forEach(section => {
      const sid = section.dataset.sectionId;
      if (!sid) return;
      initGallery(sid);
      initQuantitySelector(sid);
      initQuantityDiscount(sid);
      initStickyATC(sid);
      initAddToCart(sid);
      initShareCopy(sid);
    });
  }

  /* Lancement au chargement DOM */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init quand Shopify recharge une section (Theme Editor) */
  document.addEventListener('shopify:section:load',   init);
  document.addEventListener('shopify:section:reorder', init);

})();
